export default __webpack_public_path__ + "static/media/_datepicker.277e5b1c.css";